// One sample as the chart components consume it.
export interface MetricsSample {
  ts_ms: number;
  pod: string;
  limit_calculated: number;
  limit_to_publish: number;
  limit_with_grace: number;
  inflight: number;
  server_latency: number;
  server_cpu: number;
  server_memory: number;
  server_total_requests: number;
  redis_cpu: number;
  redis_memory: number;
  opensearch_cpu: number;
  opensearch_memory: number;
  opensearch_queues: number;
}

// Kept as aliases here for existing rate-limit imports. Both metrics pages use
// the shared range list so their header controls cannot drift apart.
export { METRICS_TIME_RANGES as TIME_RANGES } from '@/lib/metrics-time-range';
export type { MetricsTimeRange as TimeRange, MetricsTimeRangeKey as TimeRangeKey } from '@/lib/metrics-time-range';

// Polling interval when "Live tail" is on.
export const LIVE_TAIL_INTERVAL_MS = 5000;

// Target number of decimated datapoints per chart load. The server thins the
// raw 1Hz-per-pod stream down to this many time buckets across [from, to] and
// emits one averaged entry per (bucket, pod). Stays at or below the server's
// per-page cap (20000) so the UI gets the whole window in a single request.
export const PAGE_LIMIT = 15000;

// Vibrant pod-id palette borrowed from the legacy dashboard. Indexed by the
// pod's discovery order in the dataset so colors stay stable while the user
// is on the page.
export const POD_PALETTE = [
  '#4cc9f0', '#f72585', '#7209b7', '#3a0ca3', '#4361ee',
  '#4895ef', '#560bad', '#f77f00', '#06d6a0', '#118ab2',
  '#073b4c', '#ef476f', '#ffd166', '#06d6a0', '#26547c',
  '#ff6b6b', '#c0c0c0', '#48cae4', '#90be6d', '#f9844a',
];

// Latency thresholds (ms) — must match the server's adaptive-limiter config.
export const LATENCY_THRESHOLDS = [
  { value: 80,  color: '#4ade80', label: 'LinearGrowth' },
  { value: 150, color: '#fbbf24', label: 'LinearReduce' },
  { value: 200, color: '#ef4444', label: 'Reduce' },
];

// Pod variant detection. Matches the legacy classifier so the toolbar's
// "All Pods / interactive / internal-net / …" filter behaves identically.
export function podVariant(name: string): string {
  if (!name) return 'main';
  if (name.includes('interactive-internal-net')) return 'interactive-internal-net';
  if (name.includes('internal-net'))             return 'internal-net';
  if (name.includes('interactive'))              return 'interactive';
  if (name.includes('technical'))                return 'technical';
  return 'main';
}

export function isInternalPod(name: string): boolean {
  return name.includes('internal');
}
